import React from "react";

export default function Name() {
  return (
    <section className="name">
      <div className="name__description">
        <h1 className="name__title">ГБУ СО "УрНИИДВиИ"</h1>
        <h4 className="name__subtitle">
          В соответствии с Уставом государственного бюджетного учреждения
          Свердловской области «Уральский научно-исследовательский институт
          дерматовенерологии и иммунопатологии" предметом деятельности
          являются:{" "}
        </h4>
        <ul className="name__group">
          <li className="name__text">Научные исследования</li>
          <li className="name__text">Образовательная деятельность</li>
          <li className="name__text">
            Специализированная, в том числе высокотехнологичная медицинская
            помощь населению
          </li>
          <li className="name__text">
            Разработка и клинические исследования новых лекарственных препаратов
            для системной и наружной терапии
          </li>
        </ul>
      </div>
    </section>
  );
}
